/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAssetRemoveMutationVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
}>;

export type IAssetRemoveMutation = {
  __typename?: 'Mutation';
  assetRemove?: {
    __typename?: 'AssetRemovePayload';
    success: boolean;
    errors?: Array<string> | null;
    softwareEscrow:
      | {
          __typename?: 'SaasEscrow';
          id: string;
          depositStatus: Types.DepositStatusEnum;
          policy: {
            __typename?: 'SoftwareEscrowPolicy';
            activate: boolean;
            deferActivation: boolean;
            createDepositSuggestedChange: boolean;
          };
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          depositStatus: Types.DepositStatusEnum;
          policy: {
            __typename?: 'SoftwareEscrowPolicy';
            activate: boolean;
            deferActivation: boolean;
            createDepositSuggestedChange: boolean;
          };
        };
  } | null;
};

export const AssetRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assetRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetRemove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'softwareEscrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'activate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deferActivation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createDepositSuggestedChange' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAssetRemoveMutation, IAssetRemoveMutationVariables>;
